// Convert date in string format (YYYY-MM-DD) to date

export const stringToDate = (stringDate) => {
    return new Date(parseInt(stringDate.substring(0, 4)), parseInt(stringDate.substring(5, 7))-1, parseInt(stringDate.substring(8, 10)))
}
